import { getDatabase, ref, set, push, child, get } from "firebase/database";
import { triggerGlitch } from "./environment";

var portfolioCardDeck = document.getElementById("card-deck");
var portfolioTitleOpened = document.getElementById("portfolio-title-detailed");
var portfolioImageOpened = document.getElementById("portfolio-image-detailed");
var portfolioDescriptionOpened = document.getElementById("portfolio-description-opened");
const dbRef = ref(getDatabase());

get(child(dbRef, "portfolio-items")).then((snapshot) => {
  if (snapshot.exists()) {

    snapshot.forEach(element => {
        //createPortfolioCard(element.val().name, element.val().thumbnail, element.val().description, element.val().alt, element.val().picture, element.val().detailed_description);
    });
  } 
  else {
    console.log("No data available");
  }
}).catch((error) => {
  console.error(error);
});

function createPortfolioCard(title, thumb, descr, thumbAlt, pictures, detailedDesc) {
    var cardHolder = document.createElement("div");
    var cardBackground = document.createElement("div");
    var cardContent = document.createElement("div");
    var cardTitle = document.createElement("h3");
    var thumbnail = document.createElement("img");
    var descriptionHolder = document.createElement("div");
    var description = document.createElement("p");
    var sideButtons = document.createElement("div");
    var likeButton = document.createElement("button");
    var shareButton = document.createElement("button");
    var viewButton = document.createElement("button");
    var likeSVG = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    var likeSVGPath = document.createElementNS("http://www.w3.org/2000/svg", "path");
    var shareSVG = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    var shareSVGPath = document.createElementNS("http://www.w3.org/2000/svg", "path");
    
    likeSVG.setAttribute("height", "48");
    likeSVG.setAttribute("width", "48");
    likeSVG.setAttribute("viewBox", "0 96 960 960");
    
    shareSVG.setAttribute("height", "48");
    shareSVG.setAttribute("width", "48");
    shareSVG.setAttribute("viewBox", "0 96 960 960");

    likeSVGPath.setAttribute("d", "m480 935-41-37q-106-97-175-167.5t-110-126Q113 549 96.5 504T80 413q0-90 60.5-150.5T290 202q57 0 105.5 27t84.5 78q42-54 89-79.5T670 202q89 0 149.5 60.5T880 413q0 46-16.5 91T806 604.5q-41 55.5-110 126T521 898l-41 37Z");
    likeSVG.appendChild(likeSVGPath);

    shareSVGPath.setAttribute("d", "M727 976q-47.5 0-80.75-33.346Q613 909.307 613 861.669q0-6.669 1.5-16.312T619 828L316 652q-15 17-37 27.5T234 690q-47.5 0-80.75-33.25T120 576q0-47.5 33.25-80.75T234 462q23 0 44 9t38 26l303-174q-3-7.071-4.5-15.911Q613 298.25 613 290q0-47.5 33.25-80.75T727 176q47.5 0 80.75 33.25T841 290q0 47.5-33.25 80.75T727 404q-23.354 0-44.677-7.5T646 372L343 540q2 8 3.5 18.5t1.5 17.741q0 7.242-1.5 15Q345 599 343 607l303 172q15-14 35-22.5t46-8.5q47.5 0 80.75 33.25T841 862q0 47.5-33.25 80.75T727 976Z");
    shareSVG.appendChild(shareSVGPath);

    cardHolder.classList.add("portfolio-card-holder");
    cardBackground.classList.add("portfolio-card-background");
    cardContent.classList.add("portfolio-card-content");
    cardTitle.classList.add("portfolio-title");
    thumbnail.classList.add("portfolio-card-thumbnail");
    descriptionHolder.classList.add("portfolio-description");
    sideButtons.classList.add("portfolio-side-buttons");
    likeButton.classList.add("portfolio-side-button");
    shareButton.classList.add("portfolio-side-button");
    viewButton.classList.add("portfolio-button");

    cardTitle.innerHTML = title;
    
    thumbnail.setAttribute("src", thumb);
    thumbnail.setAttribute("alt", thumbAlt);

    description.innerHTML = descr;

    likeButton.setAttribute("title", "Like this portfolio piece.");
    likeButton.setAttribute("type", "button");

    shareButton.setAttribute("title", "Share this portfolio piece.");
    shareButton.setAttribute("type", "button");

    viewButton.innerHTML = "View";

    portfolioCardDeck.appendChild(cardHolder);
    cardHolder.appendChild(cardBackground);
    cardHolder.appendChild(cardContent);
    cardContent.appendChild(cardTitle);
    cardContent.appendChild(thumbnail);
    cardContent.appendChild(descriptionHolder);
    descriptionHolder.appendChild(description);
    cardContent.appendChild(sideButtons);
    sideButtons.appendChild(likeButton);
    sideButtons.appendChild(shareButton);
    cardContent.appendChild(viewButton);

    likeButton.appendChild(likeSVG);
    shareButton.appendChild(shareSVG);

    viewButton.addEventListener("click", (event) => {
      document.getElementById("portfolio-item-opened").style.opacity = "1";
      document.getElementById("portfolio-item-opened").style.display = "flex";
      triggerGlitch();
      setDetailedView(pictures, title, detailedDesc);
    });
}

function setDetailedView(pictures, title, description) {
  portfolioTitleOpened.innerHTML = title;
  portfolioImageOpened.setAttribute("src", pictures);
  portfolioDescriptionOpened.innerHTML = description;

}

var viewButtons = document.getElementsByClassName("portfolio-button");

for (var i = 0; i < viewButtons.length; i++) {
  viewButtons[i].addEventListener("click", (event) => {
    document.getElementById("portfolio-item-opened").style.opacity = "1";
    document.getElementById("portfolio-item-opened").style.display = "flex";
    triggerGlitch();
    // portfolioImageOpened.src = element.src;
    setOpenedPortfolio(event.target);
    // alert(event.target.innerHTML);
    // setDetailedView(pictures, title, detailedDesc);
  });
}

function setOpenedPortfolio(element) {
  var fullDescriptionArray = [];
  var openedImageArray = [];

  fullDescriptionArray.push("Hyper Roll is an Android game I developed in my free time. The premise is simple: you roll a ball onto incoming platforms, taking care to avoid spiked platforms. You can collect power-ups as you play, to make your time easier, and or, to increase your points. If you gain enough points, you can make it onto the global leader board. There's also a personal leader board, with your personal best scores.");
  fullDescriptionArray.push("Masters of Prep is an Android, iOS and virtual reality game developed for the Digicel Foundation with the primary goal of teaching and reinforce knowledge about disaster preparedness in the Caribbean. Made mainly for schools for students with disabilities, it focuses on various common disasters that affect Caribbean nations, such as hurricanes, fires, earthquakes and more, and teaches the students how to prepare for those disasters.");
  fullDescriptionArray.push("These were a series of networked applications developed for multiple companies to conduct and manage remote conferencing activities. These applications included features such as voice chat, to allow users within the same voice channel to talk to each other using their device's microphone, as if they were in a call, or conference call. Being a networked application done in the vein of multiplayer video games, users would control avatars they selected, and use them to traverse the virtual environment to go to meetings with businesses hosted in the space and communicate with people in designated areas. There were also general channels where users would be able to hear live announcements and updates from the hosts. Additionally, these applications also possessed the ability to collect information about user activity within the world. In some instances, this information was subsequently used to distribute prises for persons who had visited the most companies in the space. Web versions were also developed for users who didn't want to download applications. ");
  fullDescriptionArray.push("I quickly created this website from scratch with vanilla JavaScript, HTML and CSS. Much of the content is dynamically loaded in from the Firebase back end, allowing me to make changes to segments of the website without diving into any code or markup, to then redeploy the website. Firebase is also used for hosting. The 3D background of the website was created using the JavaScript library known as Three.JS. Only the background, however, was created with Three.JS. Any other 3D-seeming content such as the window tilt and mouse trails, were just created with CSS and vanilla JavaScript. ");
  fullDescriptionArray.push("This is a system that was developed for some video games, where a user could customise their character or item. The user had the ability to select articles of clothing, accessories and hairstyles for example, and apply it to their character. The user also had the ability to select any colour they chose -- and not just preset ones -- to customise their character or item to their liking. Data persistence was achieved using JSON but can be easy modified to work with something like Firebase, for example.");
  fullDescriptionArray.push("A subset of the character/item customiser, this is a colour picker that allows the user to select any colour and material value they'd like and apply it to an item.");
  fullDescriptionArray.push("A simple shader for depicting holograms in Unity applications. This shader was created using the built-in Shader Graph in Unity and works with all pipelines.");
  fullDescriptionArray.push("This is among the first games I have ever created. It's essentially a hybrid of Breakout and Pong, but with various obstacles as you play through the game. Being a space-themed game, the obstacles themselves are space-themed. These obstacles include, but aren't limited to asteroids, black holes (that function as worm holes) and nebulas. ");
  fullDescriptionArray.push("Simple FPS demo that demonstrates numerous weapon types.");
  fullDescriptionArray.push("A simple dissolve shader for Unity applications. This shader was created using the built-in Shader Graph in Unity and works with all pipelines.");
  fullDescriptionArray.push("A simple, endless, top-down space shooter with 3D assets that depicts varying weapon types and item collectables. ");
  fullDescriptionArray.push("A simple invisibility shader with a distortion effect for Unity applications. This shader was created using the built-in Shader Graph in Unity and works with all pipelines.");
  fullDescriptionArray.push("A simple demonstration of a multitude of particle systems created using the Shuriken Particle System.");

  openedImageArray.push("https://firebasestorage.googleapis.com/v0/b/joel-salazar.appspot.com/o/hyper_roll_full.jpg?alt=media&token=c501e336-3a61-40b9-a66c-8facb9a1cee9");
  openedImageArray.push("https://firebasestorage.googleapis.com/v0/b/joel-salazar.appspot.com/o/masters_of_pre_full.png?alt=media&token=c58f3006-c6dc-492c-915b-b7fd8b637dc9");
  openedImageArray.push("https://firebasestorage.googleapis.com/v0/b/joel-salazar.appspot.com/o/virtual_conferencing_full.png?alt=media&token=b0ad72e0-7a31-44a9-8dc6-44cb4033cad5");
  openedImageArray.push("https://firebasestorage.googleapis.com/v0/b/joel-salazar.appspot.com/o/website_full.png?alt=media&token=74c1af04-1559-48ae-a10a-50b65fee17fc");
  openedImageArray.push("https://firebasestorage.googleapis.com/v0/b/joel-salazar.appspot.com/o/character_item_customisation_full.png?alt=media&token=d32a28bf-3104-4aa3-a4bf-3c5d4c4baed0");
  openedImageArray.push("https://firebasestorage.googleapis.com/v0/b/joel-salazar.appspot.com/o/colour_picker_full.png?alt=media&token=896cce7f-7cbd-4649-a4c7-fcaad46bb901");
  openedImageArray.push("https://firebasestorage.googleapis.com/v0/b/joel-salazar.appspot.com/o/hologram_shader_full.png?alt=media&token=9e890c18-e74d-4f93-bf6f-566fd49077c8");
  openedImageArray.push("https://firebasestorage.googleapis.com/v0/b/joel-salazar.appspot.com/o/project_gordo_i__full.png?alt=media&token=a51389da-3ba3-42f0-b4a4-4f8006d291c8");
  openedImageArray.push("https://firebasestorage.googleapis.com/v0/b/joel-salazar.appspot.com/o/fps_demo_full.png?alt=media&token=a8e585fa-a434-4212-8efa-854495489d00");
  openedImageArray.push("https://firebasestorage.googleapis.com/v0/b/joel-salazar.appspot.com/o/dissolve_shader_full.png?alt=media&token=687aee35-14d6-4408-9843-88ca90399e32");
  openedImageArray.push("https://firebasestorage.googleapis.com/v0/b/joel-salazar.appspot.com/o/space_shooter_full.png?alt=media&token=ec306332-9cf8-4150-b925-71e50012230e");
  openedImageArray.push("https://firebasestorage.googleapis.com/v0/b/joel-salazar.appspot.com/o/invisibility_shader_full.png?alt=media&token=c708cd25-df5a-4465-b842-556f088b5393");
  openedImageArray.push("https://firebasestorage.googleapis.com/v0/b/joel-salazar.appspot.com/o/particle_system_demo_full.png?alt=media&token=8f6f7516-bbd7-4f3f-9644-20ce9cae136a");

  
  
  for (var i = 0; i < viewButtons.length; i++) {
    if (element == viewButtons[i]) {
      document.getElementById("portfolio-image-detailed").src = openedImageArray[i];
      document.getElementById("portfolio-item-opened").style.display = "flex";
      var captionText = document.getElementById("portfolio-description-opened");
      captionText.innerHTML = fullDescriptionArray[i];
      portfolioTitleOpened.innerHTML = document.getElementsByClassName("portfolio-title")[i].innerHTML;
    }
  }
}

